<template>
  <el-dialog
    :title="$t('addRechargeSetting.title')"
    :visible.sync="dialogVisible"
    width="600px"
    :close-on-click-modal="false">
    <el-form :model="addRechargeSettingForm" label-width="100px" class="add-form">
      <el-form-item 
        :label="$t('addRechargeSetting.rechargeType')" 
        prop="rechargeType"
        :rules="[
          { required: true, message: $t('addRechargeSetting.rechargeTypeRequired'), trigger: 'blur' }
        ]">
        <el-select 
          v-model="addRechargeSettingForm.rechargeType" 
          :placeholder="$t('addRechargeSetting.rechargeType')" 
          style="width: 100%"
          @change="onRechargeTypeChange">
          <el-option v-for="(item, index) in rechargeTypeOptions" :key="index" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item 
        :label="$t('addRechargeSetting.rechargeTypeName')" 
        prop="rechargeTypeName">
        <el-input 
          v-model="addRechargeSettingForm.rechargeTypeName" 
          :placeholder="$t('addRechargeSetting.rechargeTypeNamePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('addRechargeSetting.notice')">
        <el-input 
          v-model="addRechargeSettingForm.notice" 
          :placeholder="$t('addRechargeSetting.noticePlaceholder')" 
          type="textarea"
          :rows="3" />
      </el-form-item>
      <el-form-item :label="$t('addRechargeSetting.amountList')">
        <div class="amount-list-container">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addAmountRow" style="margin-bottom: 10px;">
            {{ $t('addRechargeSetting.addAmount') }}
          </el-button>
          <el-table 
            :data="amountRows" 
            border 
            style="width: 100%;"
            :show-header="true">
            <el-table-column 
              :label="$t('addRechargeSetting.faceAmount')" 
              width="140">
              <template slot-scope="scope">
                <el-input 
                  v-model.number="scope.row.faceAmount" 
                  type="number"
                  :placeholder="$t('addRechargeSetting.faceAmountPlaceholder')"
                  :min="0.01"
                  :step="0.01"
                  style="width: 120px;" />
              </template>
            </el-table-column>
            <el-table-column 
              :label="$t('addRechargeSetting.discountAmount')" 
              width="140">
              <template slot-scope="scope">
                <el-input 
                  v-model.number="scope.row.discountAmount" 
                  type="number"
                  :placeholder="$t('addRechargeSetting.discountAmountPlaceholder')"
                  :min="0.01"
                  :step="0.01"
                  style="width: 120px;" />
              </template>
            </el-table-column>
            <el-table-column 
              :label="$t('rechargeSetting.operation')" 
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="danger" 
                  size="small" 
                  icon="el-icon-delete" 
                  @click="removeAmountRow(scope.$index)"
                  :disabled="amountRows.length <= 1">
                  {{ $t('rechargeSetting.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="amount-tip">{{ $t('addRechargeSetting.amountListTip') }}</div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('addRechargeSetting.fastAmountList')">
        <div class="amount-list-container">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addFastAmountRow" style="margin-bottom: 10px;">
            {{ $t('addRechargeSetting.addAmount') }}
          </el-button>
          <el-table 
            :data="fastAmountRows" 
            border 
            style="width: 100%;"
            :show-header="true">
            <el-table-column 
              :label="$t('addRechargeSetting.faceAmount')" 
              width="140">
              <template slot-scope="scope">
                <el-input 
                  v-model.number="scope.row.faceAmount" 
                  type="number"
                  :placeholder="$t('addRechargeSetting.faceAmountPlaceholder')"
                  :min="0.01"
                  :step="0.01"
                  style="width: 120px;" />
              </template>
            </el-table-column>
            <el-table-column 
              :label="$t('addRechargeSetting.discountAmount')" 
              width="140">
              <template slot-scope="scope">
                <el-input 
                  v-model.number="scope.row.discountAmount" 
                  type="number"
                  :placeholder="$t('addRechargeSetting.discountAmountPlaceholder')"
                  :min="0.01"
                  :step="0.01"
                  style="width: 120px;" />
              </template>
            </el-table-column>
            <el-table-column 
              :label="$t('rechargeSetting.operation')" 
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="danger" 
                  size="small" 
                  icon="el-icon-delete" 
                  @click="removeFastAmountRow(scope.$index)"
                  :disabled="fastAmountRows.length <= 1">
                  {{ $t('rechargeSetting.delete') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="amount-tip">{{ $t('addRechargeSetting.fastAmountListTip') }}</div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('addRechargeSetting.lowTime')">
        <el-input 
          v-model="addRechargeSettingForm.lowTime" 
          :placeholder="$t('addRechargeSetting.lowTimePlaceholder')" 
          style="width: 100%;" />
      </el-form-item>
      <el-form-item :label="$t('addRechargeSetting.fastTime')">
        <el-input 
          v-model="addRechargeSettingForm.fastTime" 
          :placeholder="$t('addRechargeSetting.fastTimePlaceholder')" 
          style="width: 100%;" />
      </el-form-item>
     <!--  <el-form-item :label="$t('addRechargeSetting.discountRate')">
        <el-input 
          v-model="addRechargeSettingForm.discountRate" 
          :placeholder="$t('addRechargeSetting.discountRatePlaceholder')" 
          type="number"
          step="0.01"
          min="0"
          max="1" />
        <span style="color: #666; font-size: 12px;">{{ $t('addRechargeSetting.discountRateTip') }}</span>
      </el-form-item> -->
      <el-form-item :label="$t('addRechargeSetting.remark')">
        <el-input 
          v-model="addRechargeSettingForm.remark" 
          :placeholder="$t('addRechargeSetting.remarkPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('addRechargeSetting.sort')">
        <el-input 
          v-model="addRechargeSettingForm.sort" 
          :placeholder="$t('addRechargeSetting.sortPlaceholder')" 
          type="number" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('addRechargeSetting.cancel') }}</el-button>
      <el-button type="primary" @click="save">{{ $t('addRechargeSetting.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveRechargeSetting } from '@/api/admin/rechargeSettingApi'

export default {
  name: 'AddRechargeSetting',
  data() {
    return {
      dialogVisible: false,
      rechargeTypeOptions: [
        { label: this.$t('rechargeSetting.PHONE'), value: 'PHONE' },
        { label: this.$t('rechargeSetting.ELECTRIC'), value: 'ELECTRIC' },
        { label: this.$t('rechargeSetting.WATER'), value: 'WATER' },
        { label: this.$t('rechargeSetting.GAS'), value: 'GAS' },
        { label: this.$t('rechargeSetting.PROPERTY'), value: 'PROPERTY' }
      ],
      rechargeTypeNameMap: {
        'PHONE': this.$t('rechargeSetting.PHONE') + '充值',
        'ELECTRIC': this.$t('rechargeSetting.ELECTRIC') + '充值',
        'WATER': this.$t('rechargeSetting.WATER') + '充值',
        'GAS': this.$t('rechargeSetting.GAS') + '充值',
        'PROPERTY': this.$t('rechargeSetting.PROPERTY') + '充值'
      },
      addRechargeSettingForm: {
        rechargeType: '',
        rechargeTypeName: '',
        notice: '',
        amountList: '',
        fastAmountList: '',
        lowTime: '',
        fastTime: '',
        discountRate: '',
        remark: '',
        sort: 1
      },
      amountRows: [
        { discountAmount: '', faceAmount: '' }
      ],
      fastAmountRows: [
        { discountAmount: '', faceAmount: '' }
      ]
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.resetForm()
    },
    close() {
      this.dialogVisible = false
      this.resetForm()
    },
    resetForm() {
      this.addRechargeSettingForm = {
        rechargeType: '',
        rechargeTypeName: '',
        notice: '',
        amountList: '',
        fastAmountList: '',
        lowTime: '',
        fastTime: '',
        discountRate: '',
        remark: '',
        sort: 1
      }
      this.amountRows = [
        { discountAmount: '', faceAmount: '' }
      ]
      this.fastAmountRows = [
        { discountAmount: '', faceAmount: '' }
      ]
    },
    onRechargeTypeChange() {
      if (this.addRechargeSettingForm.rechargeType) {
        this.addRechargeSettingForm.rechargeTypeName = this.rechargeTypeNameMap[this.addRechargeSettingForm.rechargeType]
      } else {
        this.addRechargeSettingForm.rechargeTypeName = ''
      }
    },
    addAmountRow() {
      this.amountRows.push({ discountAmount: '', faceAmount: '' })
    },
    removeAmountRow(index) {
      if (this.amountRows.length > 1) {
        this.amountRows.splice(index, 1)
      }
    },
    addFastAmountRow() {
      this.fastAmountRows.push({ discountAmount: '', faceAmount: '' })
    },
    removeFastAmountRow(index) {
      if (this.fastAmountRows.length > 1) {
        this.fastAmountRows.splice(index, 1)
      }
    },
    buildFastAmountList() {
      const validRows = this.fastAmountRows.filter(row => row.discountAmount > 0 && row.faceAmount > 0)
      return validRows.map(row => `${row.faceAmount}:${row.discountAmount}`).join(',')
    },
    buildAmountList() {
      const validRows = this.amountRows.filter(row => row.discountAmount > 0 && row.faceAmount > 0)
      return validRows.map(row => `${row.faceAmount}:${row.discountAmount}`).join(',')
    },
    validateAmountRows() {
      const invalidRows = this.amountRows.filter(row => {
        const discountAmount = Number(row.discountAmount)
        const faceAmount = Number(row.faceAmount)
        return (discountAmount > 0 && faceAmount <= 0) || (faceAmount > 0 && discountAmount <= 0)
      })
      if (invalidRows.length > 0) {
        this.$message.error(this.$t('addRechargeSetting.amountValidationError'))
        return false
      }
      const validRows = this.amountRows.filter(row => row.discountAmount > 0 && row.faceAmount > 0)
      if (validRows.length === 0) {
        this.$message.error(this.$t('addRechargeSetting.amountRequired'))
        return false
      }
      return true
    },
    save() {
      if (!this.validateAmountRows()) {
        return
      }
      this.addRechargeSettingForm.amountList = this.buildAmountList()
      this.addRechargeSettingForm.fastAmountList = this.buildFastAmountList()
      saveRechargeSetting(this.addRechargeSettingForm)
        .then(response => {
          if (response.code === '0') {
            this.$message.success(this.$t('addRechargeSetting.addSuccess'))
            this.close()
            this.$emit('refresh')
          } else {
            this.$message.error(response.msg || this.$t('addRechargeSetting.addFailed'))
          }
        })
        .catch(error => {
          console.error('保存失败:', error)
          this.$message.error(this.$t('addRechargeSetting.addFailed'))
        })
    }
  }
}
</script>

<style scoped>
.add-form {
  margin-top: 10px;
}
.amount-list-container {
  max-height: 300px;
  overflow-y: auto;
}
.amount-tip {
  margin-top: 10px;
  color: #999;
  font-size: 12px;
}
</style>